var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadSmall = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3752 0.65625L1.62524 0.657375C1.40147 0.657375 1.18686 0.74627 1.02862 0.904503C0.870389 1.06274 0.781494 1.27735 0.781494 1.50112C0.781494 1.7249 0.870389 1.93951 1.02862 2.09775C1.18686 2.25598 1.40147 2.34487 1.62524 2.34487L26.3752 2.34375C26.599 2.34375 26.8136 2.25486 26.9719 2.09662C27.1301 1.93839 27.219 1.72378 27.219 1.5C27.219 1.27622 27.1301 1.06161 26.9719 0.903379C26.8136 0.745145 26.599 0.65625 26.3752 0.65625Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5968 9.90314C14.5184 9.82477 14.4254 9.76261 14.3231 9.72019C14.2207 9.67778 14.111 9.65595 14.0002 9.65595C13.8894 9.65595 13.7797 9.67778 13.6773 9.72019C13.575 9.76261 13.482 9.82477 13.4036 9.90314L6.65364 16.6531C6.49594 16.8115 6.40749 17.0259 6.40771 17.2494C6.40793 17.4728 6.4968 17.6871 6.65481 17.8451C6.81283 18.0031 7.02708 18.092 7.25055 18.0922C7.47401 18.0924 7.68844 18.004 7.84676 17.8463L13.1565 12.5366V28.4997C13.1565 28.7235 13.2454 28.9381 13.4036 29.0963C13.5618 29.2546 13.7764 29.3434 14.0002 29.3434C14.224 29.3434 14.4386 29.2546 14.5968 29.0963C14.7551 28.9381 14.844 28.7235 14.844 28.4997V12.5366L20.1536 17.8463C20.3119 18.0045 20.5264 18.0934 20.7502 18.0934C20.974 18.0934 21.1885 18.0045 21.3468 17.8463C21.505 17.688 21.5939 17.4734 21.5939 17.2497C21.5939 17.0259 21.505 16.8113 21.3468 16.6531L14.5968 9.90314Z",
    fill: "black",
    fillOpacity: 0.95
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload_small.afde5b28.svg";
export { ForwardRef as ReactComponent };